module.exports = __webpack_public_path__ + "img/WhatsApp-Image-2022-02-04-at-09.35.48.7c9dbb1e.jpg";